import React from "react"
import { Radio as RadioBase } from "@stardust-ds/react"

import Label from "../Label"
import styles from "./index.module.scss"

export default function Radio(props) {
  const { label, ...rest } = props

  return (
    <div className={styles.radioContainer} data-radio="data-radio">
      <RadioBase className={styles.radio} activeColor="#6CB6E3" {...rest} />
      <Label className={styles.label}>{label}</Label>
    </div>
  )
}
